/**
 * BreadcrumbSearchBarBody
 * 
 * @Author: Focci
 * @Date: 2024-01-18 10:01:23
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-18 10:01:23
 */

import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { houseSearchType } from '@lib/config'
import { IconButton } from '@comp/material'
import useApp from '@hook/useApp'
import CloseIcon from '@mui/icons-material/Close'
import FloatingDialog from '@comp/dialog/FloatingDialog'
import SearchBarAutoComplete from '@comp/page/home/search-bar/SearchBarAutoComplete'
import BreadcrumbSearchTrigger from './BreadcrumbSearchTrigger'
 
export default function BreadcrumbSearchBarBody({
  type = houseSearchType.residential
}) {
  const [open, setOpen] = useState(false)
  const handleOpen = useCallback(() => setOpen(true), [])
  const handleClose = useCallback(() => setOpen(false), [])
  const { isMobile } = useApp()

  if(isMobile) {
    return (
      <SearchBarAutoComplete
        type={type}
        ResposiveTrigger={BreadcrumbSearchTrigger} 
      />
    )
  }

  return (
    <>
      <BreadcrumbSearchTrigger onOpen={handleOpen} />
      <FloatingDialog
        width="55rem"
        DialogProps={{ open, onClose: handleClose }}
      >
        <div className="p-8 pt-12 bg-white rounded-md shadow-large relative">
          <SearchBarAutoComplete type={type} autofocus />
          <div className="absolute right-1 top-1 bg-white">
            <IconButton onClick={handleClose}>
              <CloseIcon className="text-f1.2 text-primary" />
            </IconButton>
          </div>
        </div>
      </FloatingDialog>
    </>
  )
}

BreadcrumbSearchBarBody.propTypes = {
  type: PropTypes.string,
}
